var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconQuestion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.5,
    stroke: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.27 4c-.71 0-1.27.22-1.68.66-.39.42-.59.98-.59 1.68h.8c0-.49.11-.87.32-1.15.25-.33.62-.49 1.11-.49.42 0 .75.11.99.35.22.22.33.53.33.93 0 .28-.1.54-.29.79-.07.08-.18.2-.34.36-.54.48-.88.86-1.01 1.16-.13.25-.19.54-.19.87v.23h.81v-.23c0-.27.06-.52.19-.74.1-.18.25-.36.46-.54.44-.39.72-.65.82-.77.24-.33.37-.72.37-1.17 0-.6-.19-1.07-.56-1.41-.38-.36-.9-.53-1.54-.53zm-.14 6.09c-.18 0-.32.05-.43.17-.12.11-.18.25-.18.42 0 .17.06.31.18.43.11.11.25.17.43.17.16 0 .31-.06.43-.17a.58.58 0 0 0 .17-.43c0-.17-.06-.31-.17-.42a.573.573 0 0 0-.43-.17z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuestion);
export default __webpack_public_path__ + "static/media/icon-question.d8f46bdaa9276f00f92c79faf87be374.svg";
export { ForwardRef as ReactComponent };